import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import MainHeader from 'components/templateParts/MainHeader';
import dataProvider, { UPDATE } from "providers/dataProvider";
import withForm from 'withForm';
import { salesResource } from "config/resources/salesResource";
import { compose } from 'redux'
import { withNotificationCenter } from 'NotificationCenter'
import BaseForm from 'components/ui_components/BaseForm/BaseForm.js';
import BaseFormControls from 'components/ui_components/BaseFormControls/BaseFormControls';
import style from './SalesEditContainer.module.scss'
const styles = () => ({
  main: {
    margin: '32px 26px 0',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
    backgroundColor: 'white',
    padding: '30px 15px 30px'
  },
});

const withFormConfig = salesResource.createConfig;
const inputsGroupsById = withFormConfig.inputsGroupsById;
const inputsGroupsByHash = withFormConfig.inputsGroupsByHash;

const SalesEditContainer = (props) => {
  const { history, notificationCenter, classes, inputsById, inputsByHash, handleInputs } = props;

  const handleSubmit = () => {
    if (props.isFormValid()) {
      props.resetErrors();

      let data = props.getSubmitData(true);

      dataProvider(UPDATE, 'sales', { data: data, id: props.id })
      .then((response) => {
        notificationCenter.show('Successfully updated', 'info')
        history.push('/sales/' + response.data.id + '/show');
      })
      .catch(error => {
        notificationCenter.show(error.message, 'warning')
      });
    }
  }


  return (
    <div>
      <MainHeader title="Edit Sales"/>
      <div className={classes.main}>
         <div className={style.form}>
        <BaseForm
          inputsById={inputsById}
          inputsByHash={inputsByHash}
          handleInputs={handleInputs}
          inputsGroupsById={inputsGroupsById}
          inputsGroupsByHash={inputsGroupsByHash}
        />

        <BaseFormControls
          handleClickSubmit={handleSubmit}
          deleteConfirmationMessagePostfix={'sales'}
          submitLabel="Update Sales"
          resource="sales"
          id={props.id}
          type="edit"
        />
      </div>
    </div>
    </div>
  );

}

const SalesEditWithForm = compose(
  withForm({ ...withFormConfig, mode: 'edit' }),
  withStyles(styles),
  withNotificationCenter()
)(SalesEditContainer);

// Wrapper component to extract route params and inject history from React Router v6
const SalesEditContainerWrapper = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const history = { push: navigate };
  return <SalesEditWithForm {...props} id={id} history={history} />;
};

export default SalesEditContainerWrapper;